import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  debit: [],
  tempDebit: [],
  credit: [],
  tempCredit: [],
  isLoading: false,
  creditPagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
  debitPagination: {
    total: 0,
    page: 1,
    pages: 1,
  },
};

const creditDebitSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    setDebit(state, action) {
      state.debit = action.payload;
      state.isLoading = false;
    },
    setCreditPagination(state, action) {
      state.creditPagination = action.payload;
    },
    setDebitPagination(state, action) {
      state.debitPagination = action.payload;
    },
    setTempDebit(state, action) {
      state.tempDebit = action.payload;
    },
    addDebit(state, action) {
      state.debit.push(action.payload);
      state.tempDebit.push(action.payload);
    },
    updateDebit(state, action) {
      const { index, income } = action.payload;
      console.log(index, income);
      state.debit?.splice(index, 1, income);
      state.tempDebit?.splice(index, 1, income);
    },
    deleteDebit(state, action) {
      const { index } = action.payload;
      state.debit.splice(index, 1);
      state.tempDebit.splice(index, 1);
    },
    setDebitIsLoading(state, action) {
      state.isLoading = true;
    },
    // Credit reducers
    setCredit(state, action) {
      state.credit = action.payload;
      state.isLoading = false;
    },
    setTempCredit(state, action) {
      state.tempCredit = action.payload;
    },
    addCredit(state, action) {
      state.credit.push(action.payload);
      state.tempCredit.push(action.payload);
    },
    updateCredit(state, action) {
      const { index, income } = action.payload;
      state.credit.splice(index, 1, income);
      state.tempCredit.splice(index, 1, income);
    },
    deleteCredit(state, action) {
      const { index } = action.payload;
      state.credit.splice(index, 1);
      state.tempCredit.splice(index, 1);
    },
    setCreditIsLoading(state, action) {
      state.isLoading = true;
    },
  },
});

export const {
  setDebit,
  setTempDebit,
  addDebit,
  updateDebit,
  deleteDebit,
  setDebitIsLoading,
  setCredit,
  setTempCredit,
  setCreditPagination,
  setDebitPagination,
  addCredit,
  updateCredit,
  deleteCredit,
  setCreditIsLoading,
} = creditDebitSlice.actions;
export default creditDebitSlice.reducer;
